export enum MemberStatus{
  Active = 0,
  Inactive = 1,
  Pending = 2,
}
